module.exports = __webpack_public_path__ + "static/media/info.b956ed53.svg";